import AddressesListAdd from '../../Addresses/AddressesListAdd';
import { Grid } from '@ts/storybook';
import ContactData from '@pages/DataBase/ContactData/ContactData';
import { IForm } from '@ts/ui-models';
import { IAppProps } from '@interfaces/App.interface';

interface IPersonContactDataProps extends IForm, IAppProps {
  apiBaseUrl?: string;
}
const PersonContactData = (props: IPersonContactDataProps) => {
  const { values } = props;
  return (
    <Grid container spacing={2} sx={{ width: '99%' }}>
      <Grid size={{ xs: 12 }}>
        <ContactData
          app={props.app}
          data={props.data}
          type="item"
          xTypeId={values.elementId}
          settedContactDatas={values?.personData?.XPDCDs}
          apiBaseUrl={props.apiBaseUrl || '/api/v2'}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <AddressesListAdd
          app={props.app}
          data={props.data}
          type="item"
          xTypeId={values.elementId}
          settedAddresses={values?.personData?.xPersonDataAddresses}
        />
      </Grid>
    </Grid>
  );
};

export default PersonContactData;
